import { render, staticRenderFns } from "./NotifyHistory.vue?vue&type=template&id=3e24d0a7&scoped=true"
import script from "./NotifyHistory.vue?vue&type=script&lang=js"
export * from "./NotifyHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e24d0a7",
  null
  
)

export default component.exports